<ng-container>
    <h1 class="fs-24 text-championPurple mb-3 mb-lg-4">Edit site details</h1>
    <form [formGroup]="siteForm">
        <div class="row">
            <div class="col-lg-6 mb-4">
                <div class="form-group">
                    <label for="area" class="form-label fs-15 mb-1">Floor area (sq mts) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control inputTyp1" id="area" placeholder="Floor area (sq mts)"
                        formControlName="floorArea" />
                    <p *ngIf="siteForm.get('floorArea')?.touched && siteForm.get('floorArea')?.errors" class="text-danger fs-14 mb-0">
                        Floor area is required
                    </p>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="form-group">
                    <label for="area" class="form-label fs-15 mb-1">Number of floors <span class="text-danger">*</span></label>
                    <ng-select class="form-ngselect" [clearable]="false" [searchable]="false" formControlName="floorCount">
                        <ng-option *ngFor="let floor of floors; let i = index" [value]="i+1">{{ i+1 }}</ng-option>
                    </ng-select>
                    <p *ngIf="siteForm.get('floorCount')?.touched && siteForm.get('floorCount')?.errors" class="text-danger fs-14 mb-0">
                        Floors is required
                    </p>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="form-group">
                    <label for="area" class="form-label fs-15 mb-1">Property type <span class="text-danger">*</span></label>
                    <ng-select class="form-ngselect" formControlName="propertyType" [clearable]="false" [items]="listOfPropertiesType"
                        bindLabel="name" bindValue="name"></ng-select>
                    <p *ngIf="siteForm.get('propertyType')?.touched && siteForm.get('propertyType')?.errors" class="text-danger fs-14 mb-0">
                        Property type is required
                    </p>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="form-group">
                    <label for="area" class="form-label fs-15 mb-1">Select age of the building <span class="text-danger">*</span></label>
                    <ng-select class="form-ngselect" formControlName="decadeOfBuild" [clearable]="false" [items]="listOfAgeOfBuilding"
                        bindLabel="year" bindValue="year"></ng-select>
                    <p *ngIf="siteForm.get('decadeOfBuild')?.touched && siteForm.get('decadeOfBuild')?.errors" class="text-danger fs-14 mb-0">
                        Age of building is required
                    </p>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="form-group">
                    <label for="listedGrade" class="form-label fs-15 mb-1">Listed grade <span class="text-danger">*</span></label>
                    <input type="text" class="form-control inputTyp1" id="listedGrade" placeholder="Listed grade"
                        formControlName="listedGrade" />
                    <p *ngIf="siteForm.get('listedGrade')?.touched && siteForm.get('listedGrade')?.errors" class="text-danger fs-14 mb-0">
                        <ng-container *ngIf="siteForm.get('listedGrade')?.errors?.['required']">Listed grade is required </ng-container>
                        <ng-container *ngIf="siteForm.get('listedGrade')?.errors?.['pattern']">Only alphanumeric and hyphens are allowed</ng-container>
                        <ng-container *ngIf="!siteForm.get('listedGrade')?.errors?.['pattern'] && siteForm.get('listedGrade')?.errors?.['maxlength']">Only 10 characters are allowed </ng-container>
                    </p>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="form-group">
                    <label for="premiseType" class="form-label fs-15 mb-1">Premise type <span class="text-danger">*</span></label>
                    <input type="text" class="form-control inputTyp1" id="premiseType" placeholder="Premise type"
                        formControlName="premiseType" />
                    <p *ngIf="siteForm.get('premiseType')?.touched && siteForm.get('premiseType')?.errors" class="text-danger fs-14 mb-0">
                        <ng-container *ngIf="siteForm.get('premiseType')?.errors?.['required']">Premise type is required </ng-container>
                        <ng-container *ngIf="siteForm.get('premiseType')?.errors?.['pattern']">Only alphanumeric and hyphens are allowed</ng-container>
                        <ng-container *ngIf="!siteForm.get('premiseType')?.errors?.['pattern'] && siteForm.get('premiseType')?.errors?.['maxlength']">Only 20 characters are allowed </ng-container>
                    </p>
                </div>
            </div>
        </div>
    </form>
    <p *ngIf="successMessage" class="text-success"> {{ successMessage }} </p>
    <p *ngIf="errorMessage" class="text-danger">{{ errorMessage }}</p>
    <div class="mt-4 justify-content-lg-end d-grid d-lg-flex gap-3">
        <button type="button" class="btn-secondary" (click)="close()">
            Close
        </button>
        <button [disabled]="!siteForm.valid" class="btn-primary" type="button" (click)="updateSiteData()">
            Update
        </button>
    </div>
</ng-container>